import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Modal, Button } from "react-bootstrap";
import {
  fetchAddressData,
  saveAddress,
  deleteAddress,
  setEditing,
  setFormData,
  resetForm,
} from "../../features/address/addressSlice";
import { getUserId } from "../../features/feature1/feature1Slice";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";

const AddressBook = () => {
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const userId = useSelector((state) => state.feature1.userId);
  const { addressData, formData, isEditing, status } = useSelector(
    (state) => state.address
  );

  useEffect(() => {
    if (!userId) {
      dispatch(getUserId());
    } else {
      dispatch(fetchAddressData());
    }
  }, [dispatch, userId]);

  const handleOpenModal = (address = null) => {
    if (address) {
      // Edit existing address
      dispatch(
        setEditing({
          isEditing: true,
          addressId: address._id,
          address,
        })
      );
    } else {
      // Add new address
      dispatch(setEditing({ isEditing: false }));
      dispatch(resetForm());
    }
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    dispatch(resetForm());
  };

  const handleChange = (e) => {
    dispatch(setFormData({ [e.target.name]: e.target.value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Validation
    const requiredFields = [
      "bill_to",
      "address",
      "state",
      "city",
      "pincode",
      "mobile",
      "address_type",
    ];

    const missingFields = requiredFields.filter((field) => !formData[field]);

    if (missingFields.length > 0) {
      toast.error(
        `Please fill out the following fields: ${missingFields.join(", ")}`
      );
      return;
    }

    dispatch(saveAddress({ ...formData }))
      .unwrap()
      .then(() => {
        dispatch(fetchAddressData());
        toast.success("Address saved successfully");
        handleCloseModal();
      })
      .catch((error) => {
        toast.error(
          "Failed to save address: " + (error.message || "Unknown error")
        );
      });
  };

  const handleDeleteClick = (addressId) => {
    dispatch(deleteAddress(addressId))
      .unwrap()
      .then(() => {
        dispatch(fetchAddressData());
        toast.success("Address deleted successfully");
      })
      .catch((error) => {
        toast.error(
          "Failed to delete address: " + (error.message || "Unknown error")
        );
      });
  };

  return (
    <div>
      <h2 className="manage-profile-heading">Address Book</h2>
      <div className="second-profile next edit-delete">
        <div className="pop-but">
          {status === "loading" && <p>Loading...</p>}
          {status === "failed" && <p>Error loading addresses.</p>}
          {addressData && addressData.length > 0 ? (
            addressData.map((address) => (
              <div key={address._id} className="div-imf-main d-block bg-white">
                <div className="div-imf-text p-0">
                  <div className="d-flex justify-content-between">
                    <div>
                      <h3>{address.address}</h3>
                      <h3>
                        {address.city}, {address.state} - {address.pincode}
                      </h3>
                    </div>
                    <div>
                      <span className="address_type">
                        {address.address_type}
                      </span>
                    </div>
                  </div>

                  <ul>
                    <li className="ed">
                      <Link
                        className="edit"
                        onClick={() => handleOpenModal(address)}
                      >
                        Edit
                      </Link>
                    </li>

                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={1}
                      height={15}
                      viewBox="0 0 1 15"
                      fill="none"
                    >
                      <line
                        x1="0.5"
                        y1="2.18555e-08"
                        x2="0.499999"
                        y2={15}
                        stroke="black"
                      />
                    </svg>

                    <li>
                      <Link
                        className="delete"
                        href="#"
                        onClick={() => handleDeleteClick(address._id)}
                      >
                        Delete
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            ))
          ) : (
            <p>No addresses found.</p>
          )}

          <Button
            variant="primary"
            className="btnOpenForm1 mt-3"
            onClick={() => handleOpenModal()}
          >
            Add new address
          </Button>

          <Modal show={showModal} onHide={handleCloseModal} size="md" centered>
            <Modal.Header closeButton>
              <Modal.Title id="red">
                {isEditing ? "Edit Delivery Location" : "Set Delivery Location"}
              </Modal.Title>
            </Modal.Header>
            <div className="form-container  Set-del-loc">
              <Modal.Body>
                <form onSubmit={handleSubmit}>
                  <div className="bil-to">
                    <label htmlFor="bill_to">
                      Bill to <span className="mentoory">*</span>
                    </label>
                    <textarea
                      id="bill_to"
                      name="bill_to"
                      rows={4}
                      value={formData.bill_to}
                      onChange={handleChange}
                      className="form-control"
                      required
                    />
                    <div className="tex-dow">
                      <p>
                        <strong>Note:</strong>{" "}
                        <span>
                          {" "}
                          For Rx medicines the order will be billed on patient’s
                          name
                        </span>{" "}
                        <span className="txt-limt">0/50</span>{" "}
                      </p>
                    </div>
                  </div>
                  <div className="bil-to">
                    <label htmlFor="mobile">
                      Mobile Number <span className="mentoory">*</span>
                    </label>
                    <br />
                    <input
                      type="tel"
                      id="mobile"
                      name="mobile"
                      value={formData.mobile || ""}
                      onChange={handleChange}
                      onInput={(e) => {
                        const value = e.target.value;
                        // Allow only numbers and limit input to 10 digits
                        if (/^\d{0,10}$/.test(value)) {
                          handleChange(e);
                        }
                      }}
                      className="form-control"
                      required
                    />
                    {formData.mobile && formData.mobile.length !== 10 && (
                      <span className="error-message" style={{ color: "red" }}>
                        Mobile number must be exactly 10 digits
                      </span>
                    )}
                  </div>

                  <div className="bil-to">
                    <label htmlFor="address">Address details</label>
                    <br />
                    <input
                      type="text"
                      id="address"
                      name="address"
                      value={formData.address}
                      onChange={handleChange}
                      className="form-control"
                      placeholder="House No. | Apartment Name"
                      required
                    />

                    <input
                      type="text"
                      name="land_mark"
                      value={formData.land_mark}
                      onChange={handleChange}
                      className="form-control"
                      placeholder="Landmark"
                      required
                    />
                  </div>

                  <div className="moka">
                    <div className="row">
                      <div className="col-sm-6 pe-2">
                        <div className="bil-to">
                          <label htmlFor="pincode">
                            Pincode <span className="mentoory">*</span>
                          </label>
                          <br />
                          <input
                            type="text"
                            id="pincode"
                            name="pincode"
                            value={formData.pincode}
                            onChange={handleChange}
                            className="form-control"
                            required
                          />
                        </div>
                      </div>
                      <div className="col-sm-6 ps-2">
                        <div className="bil-to">
                          <label htmlFor="city">
                            City <span className="mentoory">*</span>
                          </label>
                          <br />
                          <input
                            type="text"
                            id="city"
                            name="city"
                            value={formData.city}
                            onChange={handleChange}
                            className="form-control"
                            required
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="bil-to">
                    <label htmlFor="state">
                      State <span className="mentoory">*</span>
                    </label>
                    <br />
                    <input
                      type="text"
                      id="state"
                      name="state"
                      value={formData.state}
                      onChange={handleChange}
                      className="form-control"
                      required
                    />
                  </div>

                  {/* <div className="row">
                    <div className="col-sm-6 pe-2">
                      <div className="bil-to">
                        <label htmlFor="latitude">Latitude:</label>
                        <br />
                        <input
                          type="text"
                          id="latitude"
                          name="latitude"
                          value={formData.latitude}
                          onChange={handleChange}
                          className="form-control"
                        />
                      </div>
                    </div>
                    <div className="col-sm-6 ps-2">
                      <div className="bil-to">
                        <label htmlFor="longitude">Longitude:</label>
                        <br />
                        <input
                          type="text"
                          id="longitude"
                          name="longitude"
                          value={formData.longitude}
                          onChange={handleChange}
                          className="form-control"
                        />
                      </div>
                    </div>
                  </div> */}

                  <div className="bil-to">
                    <label htmlFor="address_type">
                      Choose Nick Name For The Address{" "}
                      <span className="mentoory">*</span>
                    </label>
                    <br />
                    <div className="button-link">
                      <div className="btn-group w-100" role="group">
                        <input
                          type="radio"
                          className="btn-check"
                          name="address_type"
                          id="home"
                          value="home"
                          checked={formData.address_type === "home"}
                          onChange={handleChange}
                        />
                        <label
                          className="btn btn-outline-primary"
                          htmlFor="home"
                        >
                          Home
                        </label>

                        <input
                          type="radio"
                          className="btn-check"
                          name="address_type"
                          id="office"
                          value="office"
                          checked={formData.address_type === "office"}
                          onChange={handleChange}
                        />
                        <label
                          className="btn btn-outline-primary"
                          htmlFor="office"
                        >
                          Office
                        </label>

                        <input
                          type="radio"
                          className="btn-check"
                          name="address_type"
                          id="other"
                          value="other"
                          checked={formData.address_type === "other"}
                          onChange={handleChange}
                        />
                        <label
                          className="btn btn-outline-primary"
                          htmlFor="other"
                        >
                          Others
                        </label>
                      </div>
                    </div>
                  </div>

                  <div className="save-adree-button">
                    <button
                      type="submit"
                      className="button button-save"
                      data-bs-dismiss="modal"
                    >
                      save address
                    </button>
                  </div>
                </form>
              </Modal.Body>
            </div>
          </Modal>
        </div>
      </div>
    </div>
  );
};

export default AddressBook;
